<template>
  <VueDatePicker
    v-bind="$attrs"
    :type="mode"
    :clearable="clearable"
    color="#1e76bd"
    :value="value"
    v-on="$listeners"
    @input="onInput"
  >
    <template #input-icon>
      <v-icon>mdi-calendar-blank-outline</v-icon>
    </template>
  </VueDatePicker>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

type VCalendarMode = 'year' | 'month' | 'quarter';

export default defineComponent({
  name: 'CfsDatePickerComponent',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Date] as PropType<string | Date>,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String as PropType<VCalendarMode>,
      default: 'date',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD',
    },
  },
  emits: ['update:modelValue', 'update:formattedValue'],
  setup(props, { emit }) {
    const onInput = (value?: string) => {
      if (props.mode === 'quarter' && value) {
        const quarter = parseInt(value.split('-')[1]) * 3;
        const quarterFormatted = quarter.toString().padStart(2, '0');

        const computedValue = `${value.split('-')[0]}-${quarterFormatted}`;
        emit('update:formattedValue', computedValue);
        emit('update:modelValue', value);
        return;
      }

      emit('update:formattedValue', value);
      emit('update:modelValue', value);
    };

    return { onInput };
  },
});
</script>

<style lang="scss">
.vd-wrapper {
  padding: 3px 15px;
  border: 1px solid #d9dbe9 !important;
  border-radius: 4px;
  background-color: var(--v-mainbg-base) !important;
  flex: 0 1 auto !important;
}

.vd-picker__input .vd-icon {
  color: #000 !important;
}

.vd-picker__input-clear:hover .vd-icon {
  color: var(--v-primary-base) !important;
}

.vd-picker__input-clear {
  align-self: center !important;
}

.vd-picker__input--is-active .vd-picker__input-icon__wrapper .v-icon {
  color: var(--v-primary-base) !important;
}
.vc-day.is-today {
  color: rgb(190, 145, 80) !important;
}
</style>
